// extracted by mini-css-extract-plugin
export default {"shuffle":"Shuffle_shuffle__F51AA"};